<template>
  <div
    class="SearchView">

    <SearchGallery
      title="Search Apps"
      :apps="appsData"
      :is-loading="loadingApps"
      :filter-map="filterMap"
      :filters="filtersData"
      :search-fields="searchFields"
      :sort-options="sortOptions"
      :sort-value="computedSortValue"
      @click-result="handleResultClick"
      @sort="handleSort"
    />

  </div>
</template>

<script>
import SearchGallery from '@/components/SearchGallery.vue';

const FILTER_MAP = [
  {
    key: 'category',
    label: 'Category',
    searchBar: true,
    searchPlaceholder: 'Search categories',
    showCount: 15,
  },
  {
    key: 'capability',
    label: 'Capability',
    searchBar: false,
    searchPlaceholder: 'Search capabilities',
    showCount: 5,
  },
  {
    key: 'publisher',
    label: 'Publisher Name',
    searchBar: true,
    searchPlaceholder: 'Search publishers',
    showCount: 5,
  },
  {
    key: 'dataSource',
    label: 'Data Source',
    searchBar: true,
    searchPlaceholder: 'Search data sources',
    showCount: 5,
  },
  {
    key: 'appType',
    label: 'App Type',
    searchBar: false,
    searchPlaceholder: 'Search app types',
    showCount: 5,
  },
];

const SEARCH_FIELDS = [
  'title',
  'category',
  'capability',
  'publisher',
  'dataSource',
  'appType',
];

const SORT_OPTIONS = [
  {
    field: 'priority',
    label: 'Relevance',
    order: 'asc',
    value: 'priority-asc',
  },
  {
    field: 'title',
    label: 'A - Z',
    order: 'asc',
    value: 'title-asc',
  },
  {
    field: 'title',
    label: 'Z - A',
    order: 'desc',
    value: 'title-desc',
  },
];

export default {
  name: 'SearchView',

  components: {
    SearchGallery,
  },

  metaInfo() {
    return {
      title: 'Data Integration Platform',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Domo\'s Integration Platform has over a thousand integrations to the tools you use every day. Use our pre-built solutions or utilize our ecosystem to build your own.',
        },
      ],
    };
  },

  data() {
    return {
      filterMap: FILTER_MAP,
      searchFields: SEARCH_FIELDS,
      sortOptions: SORT_OPTIONS,
    };
  },

  props: {
    appsData:        { type: Array,   default: () => [] },
    loadingApps:     { type: Boolean, default: true },
    filtersData:     { type: Object,  default: null },
    cachedSortValue: { type: Object,  default: null },
  },

  computed: {
    computedSortValue() {
      return this.cachedSortValue || this.sortOptions[0];
    },
  },

  methods: {
    handleResultClick(app) {
      this.$root.setOptimisticDetailData(app);

      this.$analytics.anchanchu.trackEvent('clicked app', { 'app name': app.title });

      this.$router.push({
        name: 'app-detail',
        params: {
          appType: app.type || 'app',
          appName: app.friendlyID || 'null',
          tab: 'overview',
        },
      });
    },

    handleSort(sortValue) {
      this.$root.cachedSortValue = sortValue;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.SearchView {
  position: relative;
  height: calc(100vh - 60px);
}
</style>
